import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";
import theme from "./theme";
import AppRoutes from "./AppRoutes";
import store from "../store";
import { AuthProvider } from "../context/AuthProvider";
import { NotificationProvider } from "./sse/NotificationContext";
import NotificationToaster from "./sse/NotificationToaster";
import { useEffect } from "react";
function App() {

  useEffect(() => {
    let deferredPrompt;

    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      deferredPrompt = e;

      const installBtn = document.getElementById('installBtn');
      if (installBtn) installBtn.style.display = 'block';

      if (installBtn) {
        installBtn.addEventListener('click', () => {
          deferredPrompt.prompt();
          deferredPrompt.userChoice.then((choice) => {
            if (choice.outcome === 'accepted') {
              console.log('App installed');
            }
            deferredPrompt = null;
          });
        });
      }
    });
  }, []);


  return (
    <div className="App">
      {/* <button id="installBtn" style={{ display: 'none' }}>
        Install App
      </button> */}
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <AuthProvider>
            <NotificationProvider>
              <Router>
                <AppRoutes />
                {/* <RoleBasedRoutes/> */}
              </Router>
              <NotificationToaster />
            </NotificationProvider>
          </AuthProvider>
        </Provider>
      </ThemeProvider>
    </div>
  );
}

export default App;
